<template>
    <form-row title="Wastewater" :label_align_top="true" class="pt-0">
        <div class="w-full flex flex-col">
            <input-radio-boolean
                name="has_wastewater"
                v-model="has_wastewater"
                true="Yes"
                false="No"
                class="pt-2"
                :read_only="read_only"
            />

            <div v-if="has_wastewater" class="pt-6 pb-2">
                <input-text
                    label="Where is it located now?"
                    class="w-full"
                    name="utilities_wastewater"
                    :value="commercial.utilities_wastewater"
                    :read_only="read_only"
                />

                <buyer-seller-city
                    label="Who is Responsible for bringing it to the Property Line?"
                    class="mt-5"
                    field="utilities_wastewater_who_responsible"
                    :value="commercial.utilities_wastewater_who_responsible"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
import BuyerSellerCity from '../buyer-seller-city.vue';
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    components: {
        BuyerSellerCity,
    },

    props: {
        read_only: { default: false },
        commercial: {},
    },

    data() {
        return {
            has_wastewater: this.commercial.has_wastewater,
        }
    },
}
</script>
